import React, { useState, useEffect } from 'react'

import PlacesAutocomplete from 'vendor/react-places-autocomplete-custom'

import { getCountryCodeFromCountryName } from 'utils/utils'

export default ({
    onChange,
    options,
    placeholder,
    value
}) => {
    const [inputValue, setInputValue] = useState('')

    const handleSelect = (address, placeId, suggestion, place) => {
        const addressObject = getAddressObjectFromPlace(place)

        onChange(addressObject)
    }

    const getAddressObjectFromPlace = place => {
        if(!place){
            return ''
        }

        if(place.address_components){
            const response = {}

            const responseKeys = [
                {
                    name: 'address',
                    types: ['street_number', 'route']
                },{
                    name: 'city',
                    types: ['locality', 'postal_town']
                },{
                    name: 'state',
                    types: ['administrative_area_level_1']
                },{
                    name: 'zip',
                    types: ['postal_code']
                },{
                    name: 'countryCode',
                    types: ['country']
                }
            ]

            responseKeys.forEach(key => {
                let value = ''

                key.types.forEach(type => {
                    const placeComponent = place.address_components.find(addressComponent => {
                        return addressComponent.types.indexOf(type) !== -1
                    })

                    if(placeComponent){
                        if(value){
                            value += ' '
                        }

                        let componentName = ''

                        if(key.name === 'countryCode'){
                            componentName = getCountryCodeFromCountryName(placeComponent.long_name)
                        }else{
                            componentName = placeComponent.long_name
                        }

                        value += componentName
                    }
                })

                response[key.name] = value
            })

            return response
        }
    }

    useEffect(() => {
        if(value && Object.keys(value).length){
            let newAddress = ''

            Object.keys(value).forEach((key, index) => {
                if(key === 'zip'){
                    return
                }

                if(index){
                    newAddress += ', '
                }

                newAddress += value[key]
            })
            
            setInputValue(newAddress)
        }
    }, [value])

    return (
        <div className={'address'}>
            <PlacesAutocomplete
                searchOptions={{
                    types: ['address'],
                    //componentRestrictions: {country: "au"}
                }}
                value={inputValue}
                onChange={_value => setInputValue(_value)}
                onSelect={handleSelect}
            >
                {({ 
                    getInputProps, 
                    suggestions, 
                    getSuggestionItemProps, 
                    loading 
                }) => (
                    <React.Fragment>
                        <input {...getInputProps({
                            placeholder,
                            className: 'input-standard focus-outline',
                        })} />
                        <div className={`autocomplete-dropdown-container ${ suggestions.length ? 'has-results' : '' }`}>
                            { suggestions.map((suggestion, suggestionIndex) => {
                                const {
                                    active,
                                    description
                                } = suggestion

                                const className = `suggestion ${ active ? 'active' : '' }`
                                const style = active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' }

                                return (
                                    <div 
                                        {...getSuggestionItemProps(suggestion, { className, style, })}
                                        key={suggestionIndex} 
                                    >
                                        <span>
                                            { description }
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </React.Fragment>
                )}
            </PlacesAutocomplete>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/input/address.jsx